module.exports = "../fonts/HelveticaNeueLTW01-56Italic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-56Italic.eot
// module id = MxAL
// module chunks = 1